import api from '@/api/index'

const state = {
    type_list:[],//类型资源列表
    type_obj:{},//类型资源数据，包含page,limi
    ids:'',//批量删除的多个id
    search_name:'',
    page:1,
    limit:10
}

const mutations = {
    set_ids_vuex(state,val){
        state.ids = val
    },
    set_search_name(state,val){
        state.search_name = val
    },
    set_page(state,val){
        state.page = val
    },  
    set_limit(state,val){
        state.limit = val
    },
}

const actions = {
    //删除类型数据 /单个搜索 + 批量搜索
    del_type({commit, dispatch, state, rootState}, parasm = {}) {
        api.del_type({
            access_token:localStorage.getItem("access_token"),
            ids:parasm.data.ids
        }).then(res => {
            parasm.scCallback && parasm.scCallback(res);
        }).catch(res => {
        })
    },
    //获取类型列表 /搜索
    get_type_list({commit, dispatch, state, rootState}, parasm = {}) {
        let data = state.search_name!=''?{
            access_token:localStorage.getItem("access_token"),
            name:state.search_name,
            page:state.page,
            limit:state.limit
        }:{
            access_token:localStorage.getItem("access_token"),
            page:state.page,
            limit:state.limit
        }
        api.get_type_list(data).then(res => {
            state.type_obj = res
            state.type_list = res.data
            console.log(state.type_list,'state.type_list')
            parasm.scCallback && parasm.scCallback(res);
        }).catch(res => {
        })
    },
    //添加类型
    add_type({commit, dispatch, state, rootState}, parasm = {}) {
        let data = {
            access_token:localStorage.getItem("access_token"),
            name:parasm.data.name,
            sort_weight:parasm.data.sort_weight
        }
        api.add_type(data).then(res => {
            parasm.scCallback && parasm.scCallback(res);
        }).catch(res => {
        })
    },
    //编辑类型
    edit_type({commit, dispatch, state, rootState}, parasm = {}) {
        let data ={
            access_token:localStorage.getItem("access_token"),
            id:parasm.data.id,
            name:parasm.data.name,
            sort_weight:parasm.data.sort_weight
        }
        api.edit_type(data).then(res => {
            parasm.scCallback && parasm.scCallback(res);
        }).catch(res => {
        })
    },
}

const getters = {
    type_list(){
        return state.type_list
    },
    type_obj(){
        return state.type_obj
    },
    ids(){
        return state.ids
    },
    search_name(){
        return state.search_name
    },
    page(){
        return state.page
    },
    limit(){
        return state.limit
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
